/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/087-display': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M0 1v10h16V1H0zm15 9H1V2h14v8zm-4.5 2h-5L5 14l-1 1h8l-1-1z"/>'
  }
})
